import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from 'constants/redux/cottage';

const initialState = {
  isFetching: false,
  updatingDialogs: {},
  data: {},
  lastMinuteDeals: {
    data: [],
    isLoading: false,
    created: false,
    deleted: false,
  },
  error: null,
  success: null,
  pristine: true,
};

const clearCottage = () => initialState;

const changeCottagePristine = (state, { payload }) =>
  update(state, {
    pristine: { $set: payload },
  });

const setFetchCottageRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
  });

const setFetchCottageSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: action.payload.data },
    error: { $set: null },
  });

const setFetchCottageFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: {} },
    error: { $set: action.payload.error },
  });

const setUpdateCottageRequest = (state, action) =>
  update(state, {
    updatingDialogs: { [action.payload.dialog]: { $set: true } },
  });

const setUpdateCottageSuccess = (state, action) =>
  update(state, {
    updatingDialogs: { [action.payload.dialog]: { $set: false } },
    data: { $set: action.payload.data },
    success: { $set: { code: 'informationSaved' } },
    error: { $set: null },
  });

const setUpdateCottageFailure = (state, action) =>
  update(state, {
    updatingDialogs: { [action.payload.dialog]: { $set: false } },
    error: { $set: action.payload.error },
    success: { $set: null },
  });

const setUpdateCottageIdle = (state) =>
  update(state, {
    error: { $set: null },
    success: { $set: null },
  });

const setRemoveCottageRequest = (state) =>
  update(state, {
    updatingDialogs: { onRemove: { $set: true } },
  });

const setRemoveCottageSuccess = (state) =>
  update(state, {
    updatingDialogs: { onRemove: { $set: false } },
    data: { $set: {} },
    error: { $set: null },
  });

const setRemoveCottageFailure = (state, action) =>
  update(state, {
    updatingDialogs: { onRemove: { $set: false } },
    error: { $set: action.payload.error },
  });

const setLastMinuteDealsRequest = (state) =>
  update(state, {
    lastMinuteDeals: {
      isLoading: { $set: true },
      data: { $set: [] },
      created: { $set: false },
      deleted: { $set: false },
    },
  });

const setLastMinuteDealsSuccess = (state, action) =>
  update(state, {
    lastMinuteDeals: {
      isLoading: { $set: false },
      data: { $set: typeof action.payload.data === 'object' ? action.payload.data : [] },
    },
    error: { $set: null },
  });

const setLastMinuteDealsFailure = (state, action) =>
  update(state, {
    lastMinuteDeals: {
      isLoading: { $set: false },
      data: { $set: [] },
    },
    error: { $set: action.payload.error },
  });

const setLastMinuteDealsDelete = (state) =>
  update(state, {
    lastMinuteDeals: {
      isLoading: { $set: true },
    },
    error: { $set: null },
  });

const setLastMinuteDealsCreate = (state) =>
  update(state, {
    lastMinuteDeals: {
      isLoading: { $set: true },
    },
    error: { $set: null },
  });

const setLastMinuteCreateSuccess = (state) =>
  update(state, {
    lastMinuteDeals: {
      created: { $set: true },
      deleted: { $set: false },
    },
  });

const setLastMinuteDeleteSuccess = (state) =>
  update(state, {
    lastMinuteDeals: {
      created: { $set: false },
      deleted: { $set: true },
    },
  });

export default handleActions(
  {
    [constants.CLEAR_COTTAGE]: clearCottage,

    [constants.FETCH_COTTAGE_REQUEST]: setFetchCottageRequest,
    [constants.FETCH_COTTAGE_SUCCESS]: setFetchCottageSuccess,
    [constants.FETCH_COTTAGE_FAILURE]: setFetchCottageFailure,

    [constants.COTTAGE_VERIFICATION_REQUEST]: setUpdateCottageRequest,
    [constants.UPDATE_COTTAGE_REQUEST]: setUpdateCottageRequest,
    [constants.UPDATE_COTTAGE_SUCCESS]: setUpdateCottageSuccess,
    [constants.UPDATE_COTTAGE_FAILURE]: setUpdateCottageFailure,
    [constants.UPDATE_COTTAGE_IDLE]: setUpdateCottageIdle,

    [constants.REMOVE_COTTAGE_REQUEST]: setRemoveCottageRequest,
    [constants.REMOVE_COTTAGE_SUCCESS]: setRemoveCottageSuccess,
    [constants.REMOVE_COTTAGE_FAILURE]: setRemoveCottageFailure,

    [constants.LAST_MINUTE_DEALS_REQUEST]: setLastMinuteDealsRequest,
    [constants.LAST_MINUTE_DEALS_SUCCESS]: setLastMinuteDealsSuccess,
    [constants.LAST_MINUTE_DEALS_FAILURE]: setLastMinuteDealsFailure,
    [constants.LAST_MINUTE_DEALS_DELETE]: setLastMinuteDealsDelete,
    [constants.LAST_MINUTE_DEALS_CREATE]: setLastMinuteDealsCreate,
    [constants.LAST_MINUTE_DEALS_CREATE_SUCCESS]: setLastMinuteCreateSuccess,
    [constants.LAST_MINUTE_DEALS_DELETE_SUCCESS]: setLastMinuteDeleteSuccess,

    [constants.CHANGE_COTTAGE_PRISTINE]: changeCottagePristine,
  },
  initialState,
);
